var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 13",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.33542C9 10.7901 7.45472 12.3354 5 12.3354C2.54528 12.3354 1 10.7901 1 8.33542C1 5.70125 3.8675 2.14514 4.74694 1.11653C4.77824 1.07998 4.81707 1.05065 4.86078 1.03053C4.90448 1.01042 4.95203 1 5.00014 1C5.04825 1 5.09579 1.01042 5.1395 1.03053C5.18321 1.05065 5.22204 1.07998 5.25333 1.11653C6.1325 2.14514 9 5.70125 9 8.33542Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44434 8.55762C7.44434 9.08805 7.23362 9.59676 6.85855 9.97183C6.48348 10.3469 5.97477 10.5576 5.44434 10.5576"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGout);
export default __webpack_public_path__ + "static/media/gout.c1b55877a0f5a2cf148bb72a158f26a2.svg";
export { ForwardRef as ReactComponent };